<template>
  <div class="wrapper">
    <div class="closeBtn">
      <feather-icon icon="XIcon" @click="closePage" />
    </div>
    <div class="title">
      <h1>Experiência</h1>
    </div>
    <div class="content">
      <vs-row>
        <div class="group">
          <ValidationObserver
            ref="observer"
            v-slot="{ invalid }"
            tag="form"
            @submit.prevent="submit()"
          >
            <ValidationProvider
              rules="required"
              name="empresa"
              v-slot="{ errors }"
            >
              <vs-col vs-w="6" vs-xs="12">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  v-model="payload.company"
                  type="text"
                  label="Empresa"
                  :danger="errors.length > 0"
                  :danger-text="errors[0] || ''"
                />
              </vs-col>
            </ValidationProvider>

            <ValidationProvider
              rules="required"
              name="cargo"
              v-slot="{ errors }"
            >
              <vs-col vs-w="6" vs-xs="12">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  v-model="payload.business_role"
                  type="text"
                  label="Cargo"
                  :danger="errors.length > 0"
                  :danger-text="errors[0] || ''"
                />
              </vs-col>
            </ValidationProvider>

            <vs-col
              class="flex-col my-2"
              vs-type="flex"
              vs-justify="center"
              vs-w="12"
            >
              <span class="span-label mb-1"> É meu emprego Atual </span>
              <vs-switch
                class="mb-1"
                color="primary"
                v-model="payload.is_current"
              />
            </vs-col>

            <ValidationProvider
              rules="required|monthYear"
              name="data_inicio"
              v-slot="{ errors }"
              mode="lazy"
            >
              <vs-col vs-w="6" vs-xs="6">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  type="text"
                  label="Data de início"
                  placeholder="Mês e Ano."
                  v-mask="'##/####'"
                  v-model="payload.from_date"
                  description-text="Exemplo: 01/2006"
                  :danger="errors.length > 0"
                  :danger-text="errors[0] || ''"
                />
              </vs-col>
            </ValidationProvider>

            <ValidationProvider
              :rules="payload.is_current ? '' : 'required|monthYear'"
              name="data_saida"
              v-slot="{ errors }"
              vid="confirmation"
              mode="lazy"
            >
              <vs-col vs-w="6" vs-xs="6">
                <vs-input
                  class="w-full no-icon-border mb-1"
                  type="text"
                  :label="payload.is_current ? 'Data de saída' : 'Data de saída'"
                  :placeholder="payload.is_current ? 'É meu emprego Atual' : 'Mês e Ano.'"
                  v-mask="'##/####'"
                  :disabled="payload.is_current"
                  v-model="payload.to_date"
                  :description-text="payload.is_current ? '' : 'Exemplo: 01/2006'"
                  :danger="errors.length > 0"
                  :danger-text="errors[0] || ''"
                />
              </vs-col>
            </ValidationProvider>

            <vs-col vs-w="12">
              <vs-textarea
                class="w-full no-icon-border my-8"
                v-model="payload.description"
                rows="5"
                name="description"
                type="text"
                placeholder="A Experiência Profissional é um campo do currículo que deve ser preenchida após uma análise aprofundada do seu histórico profissional. Como exemplo de informações que podem constar neste campo, destacamos: os nomes das empresas, período trabalhado, título do cargo e principais atividades exercidas."
                label="Descrição"
              />
            </vs-col>

            <div class="mobile-hidden">
              <vs-col class="p-0" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col vs-w="10" vs-sm="10">
                  <vs-input
                    @keyup.enter="handleAddSkill"
                    class="w-full no-icon-border"
                    v-model="skills"
                    placeholder="comunicativo, liderança com desafios, administração de tempo"
                    name="skills"
                    type="text"
                    label="Habilidades/Conhecimentos"
                    description-text="Adicione mais de uma habilidade profissional, separando por virgula"
                  />
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-align="center"
                  vs-justify="center"
                  vs-w="2"
                  vs-sm="2"
                >
                  <vs-button
                    @click="handleAddSkill"
                    color="primary"
                    type="border"
                    icon="add"
                  >
                    Adicionar
                  </vs-button>
                </vs-col>
              </vs-col>
              <vs-col vs-w="12">
                <vs-chip
                  closable
                  v-for="(item, index) in payload.skills"
                  :key="`skill-${index}`"
                  class="my-2 ml-1"
                  color="#708090"
                  @click="handleRemoveSkill(item)"
                >
                  {{ item }}
                </vs-chip>
              </vs-col>
            </div>
            <vs-col vs-w="12">
              <button
                :style="
                  invalid
                    ? { opacity: 0.5, backgroundColor: color }
                    : { opacity: 1, backgroundColor: color }
                "
                class="mt-5 button"
                type="submit"
              >
                Salvar
              </button>
            </vs-col>
          </ValidationObserver>
        </div>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { isBefore, format, formatDistanceStrict } from "date-fns";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ptBR from "date-fns/locale/pt-BR";

export default {
  props: ["experience"],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    payload: {
      skills: [],
      index: 0,
      to_date: "",
      period: "",
      company: "",
      from_date: "",
      description: "",
      is_current: false,
      popupActive: false,
      business_role: "",
    },
    skills: "",
  }),
  watch: {
    "payload.is_current": function () {
      if (this.payload.is_current) {
        this.payload = {
          ...this.payload,
          to_date: null,
        };
      }
    },
  },
  computed: {
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      this.$vs.loading({ text: "Enviando... " });

      const { company_label } = this.$router.history.current.params;

      this.$http
        .post(`api/v1/talent/${company_label}/user/talent?step=experiences`, {
          experiences: [
            {
              ...this.payload,
              to_date: this.payload.is_current ? null : "01/".concat(this.payload.to_date),
              from_date: "01/".concat(this.payload.from_date),
              period: this.payload.is_current
                ? this.formatPeriodlWithis_current()
                : this.formatPeriodWithoutis_current(),
            },
          ],
        })
        .then((response) => {
          this.$vs.loading.close();

          if (this.payload.id) {
            this.$store.dispatch("experience/update", {
              ...this.payload,
            });
          } else {
            this.$store.dispatch("experience/store", {
              ...this.payload,
              id: response.data.data.experiences[0].id,
            });
          }

          this.$router.back();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    closePage() {
      this.$router.back();
    },
    handleRemoveSkill: function (skill) {
      let skills = [...this.payload.skills];

      this.payload = {
        ...this.payload,
        skills: skills.filter((sk) => sk !== skill),
      };
    },
    handleAddSkill: function () {
      const _skills = this.skills.split(",").filter((skill) => skill != "");

      this.payload = {
        ...this.payload,
        skills: [...this.payload.skills, ..._skills],
      };
    },
    setCurrentDate() {
      const split = format(new Date(), "MM/dd/yyyy").split("/");

      return `${split[0]}/${split[2]}`;
    },
    formatPeriodWithoutis_current() {
      const { from_date, to_date } = this.payload;
      const splitFrom = "01/".concat(from_date).split("/");
      const splitTo = "01/".concat(to_date).split("/");
      const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
      const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

      return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true });
    },
    formatPeriodlWithis_current() {
      const { from_date } = this.payload;
      const splitFrom = "01/".concat(from_date).split("/");

      const from = new Date(splitFrom[2], splitFrom[1] - 1, splitFrom[0]);
      const to = new Date();

      return formatDistanceStrict(from, to, { locale: ptBR, addSuffix: true });
    },
  },
  created() {
    this.$validator.extend(
      "monthYear",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique a data informada",
        validate: (value) =>
          new Promise((resolve) => {
            if (parseInt(value.split("/")[0]) > 12)
              resolve({
                valid: false,
                data: {
                  message: `O mês ${
                    value.split("/")[0]
                  } informado não é válido!`,
                },
              });
            else
              resolve({
                valid: true,
                data: { message: "" },
              });
          }),
      },
      { hasTarget: true, immediate: false }
    );

    this.$validator.extend(
      "compareDate",
      {
        getMessage: (field, params, data) =>
          (data && data.message) || "Verifique as datas de início e saída",
        validate: (value) => {
          return new Promise((resolve) => {
            if (!this.payload.is_current) {
              if (this.payload.from_date == "")
                resolve({
                  valid: false,
                  data: { message: "A data de início está vazia!" },
                });

              const splitFrom = "01/".concat(this.payload.from_date).split("/");
              const splitTo = "01/".concat(value).split("/");

              const monthReg = /0[1-9]|1[0-2]/;
              const yearReg = /(?:(?:19|20)[0-9]{2})/;

              if (!splitFrom[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitFrom[1]} informado na data de início não é válido!`,
                  },
                });
              if (!splitTo[1].match(monthReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O mês ${splitTo[1]} informado não é válido!`,
                  },
                });

              if (!splitFrom[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitFrom[2]} informado na data de início não é válido!`,
                  },
                });
              if (!splitTo[2].match(yearReg))
                resolve({
                  valid: false,
                  data: {
                    message: `O ano ${splitTo[2]} informado não é válido!`,
                  },
                });

              const from = new Date(
                splitFrom[2],
                splitFrom[1] - 1,
                splitFrom[0]
              );
              const to = new Date(splitTo[2], splitTo[1] - 1, splitTo[0]);

              resolve({
                valid: isBefore(from, to),
                data: {
                  message: `${
                    isBefore(from, to)
                      ? ""
                      : "A data de finalização não pode ser menor que a data de início"
                  }`,
                },
              });
            }
          });
        },
      },
      { hasTarget: true, immediate: false }
    );

    if (this.experience) {
      this.payload = {
        ...this.experience,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  padding: 16px;
  background: #fff;

  @media screen and (min-width: 768px) {
    padding: 36px;
  }
}

.closeBtn {
  display: flex;
  justify-content: flex-end;
}

.title {
  display: flex;
  justify-content: center;

  h1 {
    font-size: 20px;
  }
}

.content {
  padding: 16px 0;
  display: flex;
  justify-content: center;
}

.group {
  width: 100%;
  margin: 16px auto;

  @media only screen and (min-width: 1020px) {
    width: 70%;
  }
}

.button {
  width: 100%;
  display: flex;
  padding: 1rem;
  color: white;
  font-size: 1.25rem;
  border: 0;
  border-radius: 5px;
  justify-content: center;
  background-color: #1551b1;
}
</style>
